module.exports = "<a id=\"menu_toggle\" (click)='resize()'>\n    <i class=\"fa fa-bars\"></i>\n</a>"


//////////////////
// WEBPACK FOOTER
// ./src/dashboard/app/modules/space/menu/resizer/menu.resizer.template.html
// module id = 2603
// module chunks = 0